import { AlertCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

export interface ErrorStateProps {
  title?: string;
  message?: string;
  onRetry?: () => void;
  retryLabel?: string;
  className?: string;
}

/**
 * Standard error block with optional retry — matches Schools list pattern.
 */
export function ErrorState({
  title = "Something went wrong",
  message,
  onRetry,
  retryLabel = "Try again",
  className,
}: ErrorStateProps) {
  return (
    <div
      className={cn(
        "flex flex-col items-center gap-3 rounded-md border border-destructive/30 bg-destructive/5 py-12 text-center",
        className,
      )}
      role="alert"
    >
      <AlertCircle className="h-5 w-5 text-destructive" aria-hidden />
      <div className="space-y-1">
        <p className="text-sm font-medium leading-6 text-foreground">{title}</p>
        {message ? (
          <p className="text-xs font-normal leading-5 text-muted-foreground">{message}</p>
        ) : null}
      </div>
      {onRetry ? (
        <Button variant="outline" size="sm" onClick={onRetry}>
          {retryLabel}
        </Button>
      ) : null}
    </div>
  );
}
